<template>
  <eepos-header
    :username="userName()"
    :testing="this.isTestingSystem()"
    :token="token"
    :locale="this.$i18n.locale"
    @logout-click="onLogoutClick"
  >
    <router-link to="/">
      {{ $t("general.references") }}
    </router-link>
  </eepos-header>
</template>

<script>
import { kee } from "../keecloak.js";

export default {
  props: {
    //currentPath: String
  },
  data() {
    return {
      token: null
    };
  },
  created() {
    this.token = kee.token;
    kee.onTokenUpdate = token => {
      this.token = token;
    };
  },
  methods: {
    isTestingSystem() {
      return process.env.VUE_APP_DEVELOP_SYSTEM;
    },
    userName() {
      return kee.userInfo?.name;
    },
    onLogoutClick() {
      kee.logout();
    },
    routeHome() {
      this.$router.go(-1);
    }
  },
  computed: {
    currentPath() {
      alert(this.$route.path);
      return this.$router.currentRoute.path;
    }
  }
};
</script>